var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailNewletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.2365 17.2528C28.2365 20.9729 25.074 23.9863 21.135 23.9996H21.1209H7.12972C3.20484 23.9996 0 20.9996 0 17.2795V17.2662C0 17.2662 0.00847095 11.3647 0.0197656 8.39669C0.0211774 7.83935 0.698854 7.52735 1.16052 7.87402C4.51502 10.3874 10.5139 14.9701 10.5887 15.0301C11.5911 15.7888 12.8617 16.2168 14.1606 16.2168C15.4595 16.2168 16.7301 15.7888 17.7325 15.0155C17.8074 14.9688 23.6721 10.5234 27.0774 7.96869C27.5405 7.62068 28.221 7.93269 28.2224 8.48869C28.2365 11.4341 28.2365 17.2528 28.2365 17.2528Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4974 3.56539C26.2748 1.38936 23.869 0 21.2205 0H7.13044C4.48186 0 2.07611 1.38936 0.853467 3.56539C0.579573 4.05206 0.709461 4.65874 1.16548 5.00275L11.6483 12.9215C12.3824 13.4815 13.2719 13.7602 14.1613 13.7602C14.167 13.7602 14.1712 13.7602 14.1755 13.7602C14.1797 13.7602 14.1853 13.7602 14.1896 13.7602C15.079 13.7602 15.9685 13.4815 16.7026 12.9215L27.1854 5.00275C27.6414 4.65874 27.7713 4.05206 27.4974 3.56539Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNewletter);
export default __webpack_public_path__ + "static/media/email-newletter.58ae406979804824e837659a2c11b370.svg";
export { ForwardRef as ReactComponent };